import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { MdReadMore } from 'react-icons/md'
import CreateReturnToShelf from '../Components/CreateReturnToShelf'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import ScnDetails from '../Components/ScnDetails'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { AllSCN, AllSraProduct, ExpectedAllSCN } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'
import SearchComponent from '../Components/SearchComponent'

export default function ExpectedSCN() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [SearchText, setSearchText] = useState("");


  const [OpenModal, setOpenModal] = useState(false);
  const [SingleData, setSingleData] = useState([]);
  const [Data, setData] = useState([]);

  const [CurrentPage, setCurrentPage] = useState(1);
  const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
  const [PreLoader, setPreLoader] = useState(true);

  //get current post

  const indexOfLastSra = CurrentPage * PostperPage;
  const indexOfFirstSra = indexOfLastSra - PostperPage;
  const currentData = Data?.slice(indexOfFirstSra, indexOfLastSra);
  //change page 
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber)
  }
  const ReturntoStore = () => {

    onOpen()
  }

  const AllStoreCreditNote = async () => {
    let result = await ExpectedAllSCN()

    console.log("expectedallscn", result);

    if (result.status == true) {
      setData(result.queryresult.allrequest)
      setPreLoader(false)
    }
  }

  const ReadMore = (id) => {

    onOpen()
    setSingleData(id)

  }

  useEffect(() => {
    AllStoreCreditNote()
  }, [isOpen]);
  return (
    <MainLayout>
      {
        PreLoader && (

          <Preloader />
        )
      }
      <Seo title="Return to Store" description='IMS Return to store ' />

      <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"} >


        <Text textTransform="capitalize">Total Returned Products - {Data.length}</Text>

      </Flex>

      <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"Ticket ID,Staff ID, Product Name"} />


      <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>


        <Table variant='simple' size='sm' overflowX="auto" >
          <Thead>
            <Tr>
              <Th color="#fff">S/N</Th>
              <Th color="#fff">Ticket ID</Th>
              <Th color="#fff">Product name</Th>
              <Th color="#fff">Staff Id</Th>
              <Th color="#fff">Qty Requested</Th>
              <Th color="#fff">Qty To Return</Th>
              <Th color="#fff">Status</Th>
              <Th color="#fff">Date Requested</Th>
              <Th color="#fff">Action</Th>

            </Tr>
          </Thead>
          <Tbody>
            {


              SearchText === "" ? (
                currentData?.map((item, i) => (
                  <TableRow
                    key={i}
                    sn={i + 1}
                    ticketNo={item.ticket}
                    type="expectedReturnToStore"
                    productName={item.productname}
                    staffId={item.staffid?.toLocaleString()}
                    qty={item.qtyrequested?.toLocaleString()}
                    qtyinspected={item.qtytoreturn?.toLocaleString()}
                    status={item.returned}
                    dateReceived={moment(item.requestdate).format("DD/MM/YYYY")}
                    onClick={() => ReadMore(item._id)}

                  />
                ))
              ) : (
                SearchText !== "" && Data.filter(item => item.ticket?.includes(SearchText) || item.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.staffid?.includes(SearchText)).length > 0 ? (

                  Data?.filter(item => item.ticket?.includes(SearchText) || item.staffid?.includes(SearchText) || item.productname?.includes(SearchText)).

                    map((item, i) => (
                      <TableRow
                        key={i}
                        sn={i + 1}
                        ticketNo={item.ticket}
                        type="expectedReturnToStore"
                        productName={item.productname}
                        staffId={item.staffid?.toLocaleString()}
                        qty={item.qtyrequested?.toLocaleString()}
                        qtyinspected={item.qtytoreturn?.toLocaleString()}
                        status={item.returned}
                        dateReceived={moment(item.requestdate).format("DD/MM/YYYY")}
                        onClick={() => ReadMore(item._id)}

                      />
                    ))
                ) : (
                  <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>

                )

              )
            }
          </Tbody>

        </Table>


        <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />


      </Box>

      <CreateReturnToShelf state="expectedScn" sendingId={SingleData} isOpen={isOpen} onClose={onClose} />
    </MainLayout>
  )
}
